<template>
    <div class="wlx-site-manager-wrapper wlx-user-manager">
        <header class="site-manager-head-con" style="padding-top:20px;">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="stuName" placeholder="请输用户名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getStudentResultInfo()">搜索</el-button>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo">新增</el-button>
                </el-form-item>
            </el-form>
        </header>

        <el-table :data="list">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column prop="username" label="用户名"></el-table-column>
            <el-table-column prop="displayName" label="姓名"></el-table-column>
            <el-table-column prop="dateCreated" label="创建日期"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-dropdown @command="handleMenu">
                        <el-button size="mini" type="primary" style="margin: 0 15px;">菜单管理<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{type:1,id: scope.row.id }">官网</el-dropdown-item>
                            <el-dropdown-item :command="{ type: 2, id: scope.row.id }">资源库</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="编辑" :modal="false" :visible.sync="dialogFormVisible" width="800px">
            <el-form :inline="true" :model="from" class="demo-form-inline" label-width="200px">
                <el-form-item label="用户名：">
                    <el-input v-model="from.account"></el-input>
                </el-form-item>
                <el-form-item label="姓名：">
                    <el-input v-model="from.name"></el-input>
                </el-form-item>
                <el-form-item label="密码：">
                    <el-input placeholder="请输入密码" v-model="from.pwd" show-password></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelInfo">取 消</el-button>
                <el-button type="primary" @click="editInfo()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogTitle:"",
            checkList: [],
            page: 1,
            pageSize: 10,
            totalCount: 0,
            stuName: "",
            schoolName: "",
            idCard: "",
            certificateNum: "",
            examinationTypeId: "",
            examinationGradeId: "",
            list: [],
            from: {
                id: "",
                account: "",
                name:"",
                pwd: ""
            },
            files: [],
            urlAliyunOSS: "/api/design/osssign/getsign",
            //编辑信息
            dialogFormVisible: false,
            //导入
            ImportDialogVisible: false,
            uploadUrl: "/api/XOrg/CertificateManager/uploadExcel",
            fileList: [], //导入文件
            errorList: [], //错误信息
            certTypeList: [],
            certGradeList: [],
            certTypeId: "",
            searchCertTypeList: [],
            searCertGradeList: [],
            // 批量删除
            DeleteAllDialogVisible: false,
            deleteStartTime: "",
            deleteEndTime: "",
            isCJ: 1,
            isZJ: 1,
            isGJ: 1,
        };
    },
    created() {
        this.getAdminUserList();
    },
    methods: {
        getAdminUserList() {
            var that = this;
            this.$http
                .post("/api/XOrg/PermissionUser/getAdminUserList")
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.list = rst.userList;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        cancelInfo() {
            this.from.name = "";
            this.from.pwd = "";
            this.from.account = "";
            this.dialogFormVisible = false;
        },
        addInfo() {
            this.dialogTitle = '新增';
            this.dialogFormVisible = true;
        },
        //编辑
        editInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/PermissionUser/saveAdminUser", {
                    id: this.from.id,
                    username: this.from.account,
                    displayname: this.from.name,
                    password: this.from.pwd
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                        that.cancelInfo();
                        that.getAdminUserList();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //弹出框赋值
        handleEdit(row) {
            this.dialogTitle = '编辑';
            this.from.id = row.id;
            this.from.account = row.username;
            this.from.name = row.displayName;
            this.dialogFormVisible = true;
        },
        //删除
        deleteInfo(id) {
            var that = this;
            this.$confirm("此操作将删除该用户数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/PermissionUser/deleteUser", {
                        id: id,
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getAdminUserList();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        handleMenu(item) { 
            this.$router.push({
                name:"userMenu",
                params: {
                    userId: item.id,
                    menuType: item.type
                }
            })
        }
    },
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    .demo-form-inline {
        .el-input__inner {
            width: 200px;
        }

        .img_upload {
            width: 500px;
        }
    }
}
</style>